import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));
const EmployeesList = lazy(() =>
  import("../../container/employees/EmployeesList")
);
const AddEmployee = lazy(() =>
  import("../../container/employees/components/createEmployeeForm")
);

function IconsRoute() {
  return (
    <Routes>
      <Route path="/" element={<EmployeesList />} />
      <Route path="/add-employee" element={<AddEmployee />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default IconsRoute;
